<template>
  <label class="CCheckbox" :class="{ 'pointer-events-none': props.disabled }">
    <input
      type="checkbox"
      :disabled="props.disabled"
      :checked="isChecked"
      @change="changeStatus"
    />
    <div class="custom-checkbox"></div>
    <input
      v-if="props.textInput"
      :value="props.textValue"
      :type="inputType"
      :id="props.id"
      :placeholder="props.placeholder"
      :disabled="!isChecked"
      :maxlength="props.maxLength"
      :class="{ 'pr-[33px]': props.password }"
      @input="inputVal($event.target.value)"
    />
    <span v-else class="PC_Body2-R">
      {{ props.label }}
    </span>
  </label>
</template>

<script setup>
import { ref, computed } from "vue";

const props = defineProps({
  disabled: { type: Boolean, default: false },
  modelValue: { type: [Array, Boolean, Number, String, Object], default: null },
  value: { type: [Number, Boolean, String], default: 0 },
  label: { type: String, default: "Name" },
  textInput: { type: Boolean, default: false },
  require: { type: Boolean, default: false },
  type: { type: String, default: "text" },
  id: { type: String, default: "Input01" },
  placeholder: { type: String, default: "Name" },
  textValue: { type: String, default: "" },
  maxLength: { type: Number, default: 9999 },
  password: { type: Boolean, default: false },
});

const showPassword = ref(false);
const inputType = computed(() =>
  props.password && showPassword.value ? "text" : props.type
);

const emit = defineEmits([
  "update:modelValue",
  "update:textValue",
]);

const isChecked = computed(() => {
  if (Array.isArray(props.modelValue)) {
    return props.modelValue.includes(props.value);
  }
  return props.modelValue == 1 || props.modelValue === true;
});

const changeStatus = (e) => {
  const checked = e.target.checked;
  if (Array.isArray(props.modelValue)) {
    const next = [...props.modelValue];
    const idx = next.indexOf(props.value);
    if (checked && idx === -1) next.push(props.value);
    if (!checked && idx !== -1) next.splice(idx, 1);
    emit("update:modelValue", next);
  } else {
    const next = checked ? 1 : 0;
    emit("update:modelValue", next);
  }
};

const inputVal = (value) => {
  // console.log("value : ",value);
  emit("update:textValue", value);
};
</script>

<style lang="scss" scoped>
//custom checkbox
.CCheckbox {
  display: inline-block;
  position: relative;
  padding-left: 33px;
  cursor: pointer;
}

.CCheckbox input[type="checkbox"] {
  display: none;
}

.custom-checkbox {
  position: absolute;
  top: 50%;
  left: 0px;
  transform: translate(0px, -50%);
  height: 20px;
  width: 20px;
  border-radius: 5px;
  background-color: transparent;
  border: 1px solid #9b237b;
}

.CCheckbox input[type="checkbox"]:checked + .custom-checkbox {
  background-color: #9b237b;
  border: 1px solid #9b237b;
}

.CCheckbox input[type="checkbox"]:checked + .custom-checkbox::before {
  content: "";
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z' fill='%239B237B'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M18.3468 5.96294C18.8091 6.26518 18.9388 6.88492 18.6366 7.34716L11.8366 17.7472C11.6763 17.9923 11.4167 18.1547 11.1262 18.1918C10.8358 18.229 10.5436 18.1368 10.3269 17.9398L5.92694 13.9399C5.51828 13.5683 5.48817 12.9359 5.85968 12.5272C6.23118 12.1186 6.86363 12.0885 7.27228 12.46L10.8045 15.6711L16.9627 6.25267C17.2649 5.79043 17.8846 5.66072 18.3468 5.96294Z' fill='white'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
//custom checkbox
input:not(input[type="checkbox"]) {
  width: 100%;
  height: 50px;
  border: 0.1px solid #c8c8c8;
  border-radius: 8px;
  padding: 9px;
  font-size: 16px;
  line-height: 100%;
  &:focus {
    border: 1px solid #9b237b;
    outline: none;
    box-shadow: none !important;
  }
}
</style>